var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAction03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#FF8D56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.15 43.0249C52.815 43.0249 51.925 44.3599 51.925 45.2499V56.3749H47.475V45.2499C47.475 43.9149 46.585 43.0249 45.25 43.0249C43.915 43.0249 43.025 44.3599 43.025 45.2499V56.3749H38.575V45.2499C38.575 43.9149 37.685 43.0249 36.35 43.0249C35.015 43.0249 34.125 44.3599 34.125 45.2499V59.9349C34.125 63.9399 37.24 67.0549 40.8 67.4999V98.6499C40.8 101.32 42.58 103.1 45.25 103.1C47.92 103.1 49.7 101.32 49.7 98.6499V67.4999C53.26 67.0549 56.375 63.9399 56.375 59.9349V45.2499C56.375 44.3599 55.485 43.0249 54.15 43.0249ZM63.05 45.2499V71.9499H67.5V98.6499C67.5 101.32 69.28 103.1 71.95 103.1C74.62 103.1 76.4 101.32 76.4 98.6499V31.8999C68.835 31.8999 63.05 37.6849 63.05 45.2499ZM94.2 40.7999C87.97 40.7999 83.075 47.4749 83.075 55.4849C82.63 60.8249 85.3 65.7199 89.75 68.8349V98.6499C89.75 101.32 91.53 103.1 94.2 103.1C96.87 103.1 98.65 101.32 98.65 98.6499V68.8349C103.1 65.7199 105.77 60.8249 105.325 55.4849C105.325 47.4749 100.43 40.7999 94.2 40.7999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction03);
export default __webpack_public_path__ + "static/media/action03.9d15617f4faa6554b372eb09da842e73.svg";
export { ForwardRef as ReactComponent };